<template>
  <v-app>
    <v-app-bar
      v-if="loggedIn"
      app
      color="white"
      class="elevation-0"
    >
      <div class="ma-5 py-4">
        <v-img src="./assets/RareCyte_Header_Logo.png" />
      </div>
      <v-spacer></v-spacer>
      <div>
        <v-text-field
          v-model="searchPortal"
          class="mt-7"
          outlined
          dense
          label="Search Portal"
          clear-icon="mdi-close"
          clearable
          append-icon="mdi-magnify"
          @click:append="searchPost"
          @click:clear="searchPortal=''"
          @keydown.enter="searchPost"
        ></v-text-field>
      </div>
      <v-divider vertical class="mx-5"></v-divider>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            class="ma-5 py-4 d-none d-lg-flex"
            v-bind="attrs"
            v-on="on"
            text
            x-small
          >
           Welcome, {{ customerName }}
            <v-icon class="">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item 
            link
            to="/my-account"
          >
            <v-list-item-icon>
              <v-icon  small>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item>My Account</v-list-item>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item 
          link
          to="/logout">
            <v-list-item-icon>
              <v-icon small>mdi-power</v-icon>
            </v-list-item-icon>
            <v-list-item>Logout</v-list-item>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-app-bar-nav-icon class="ma-5 py-4 d-flex d-lg-none" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      v-if="loggedIn"
      v-model="drawer"
      fixed
      temporary
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group
          active-class="secondary white--text"
        >
          <v-list-item
            link
            to="/home"
          >
            <v-list-item-icon>
              <v-icon>mdi-home-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
          <v-list-item
            v-for="item in navigation.top"
            :key="item.category_id"
            link
            :to="item.category_slug"
          >
            <v-list-item-icon>
              <v-icon v-text="item.category_icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.category_name_display"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            link
            to="/my-account"
          >
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>My Account</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            to="/logout"
          >
            <v-list-item-icon>
              <v-icon>mdi-power</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      
    </v-navigation-drawer>
   
    <v-card 
      v-if="loggedIn"
      id="top-navigation" 
      class="d-none d-lg-flex"
      color="white"
    >
      <v-card-text class="text-center my-n2">
        <v-btn
          class="mx-3 text-center"
          text
          link
          active-class="top-nav-active"
          to="/home"
        >
         Home
        </v-btn>

        <v-menu
          v-for="item in topNav"
         :key="item.category_id"
          open-on-hover
          bottom
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              text
              link
              active-class="top-nav-active"
              :href="'/#/' + item.category_slug"
            >
              {{ item.category_name_display }}
            </v-btn>
          </template>
          <v-list
            v-for="subItem in item.subcats"
          :key="subItem.category_id"
            nav
            dense
          >
            <v-list-item v-if="subItem.category_slug === 'faq' || subItem.category_slug === 'frequently-asked-questions'"
              link
              :href="'/#/' + subItem.category_slug"
              active-class="top-nav-active"
            >
              {{ subItem.category_name_display }}
            </v-list-item>
            <v-list-item v-else
              active-class="top-nav-active"
              link
              :href="'/#/' + subItem.category_id + '/' + subItem.category_slug"
            >
              {{ subItem.category_name_display }}
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu
          v-if="pd"
          open-on-hover
          bottom
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              text
              active-class="top-nav-active"
            >
              Orion
            </v-btn>
          </template>
          <v-list
            nav
            dense
          >
            <v-list-item 
              link
              active-class="top-nav-active"
              @click="pdlogin('Designer')"
            >
              Panel Designer 
            </v-list-item>
            <v-list-item 
              link
              active-class="top-nav-active"
              @click="pdlogin('Catalog')"
            >
              Reagent Catalog 
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- <v-btn
          v-if="pd"
          class="mx-3 text-center"
          text
          @click="pdlogin"
        >
         Orion (dropdown > Panel Designer : Reagent Catalog)
        </v-btn> -->
      </v-card-text>
      
    </v-card>
    
    <v-main>
      <router-view/>
    </v-main>
    
    <v-footer v-if="loggedIn" class="pa-1">
      <v-container>
        <v-row>
          <v-col class="caption text-center grey--text text--darken-1">
            &copy; Copyright {{ copyright.getFullYear() }} RareCyte, Inc. All rights reserved.<br>
            RareCyte, Inc. 2601 Fourth Ave, #500, Seattle, WA 98121, United States
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
   
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    loggedIn: false,
    drawer: false,
    navigation: {
      top: null,
      side: null
    },
    topNav: [],
    copyright: new Date(),
    customerName: null,
    customerEmail: null,
    searchPortal: '',
    pd: null
  }),
  beforeMount () {
    this.pageInit()

    this.$root.$on('_logoutCustomer',() => {
      this.logoutCustomer()
    })

    this.$root.$on('notify',(type,msg) => {
      this.showToasts(type,msg)  
    })

  },
  mounted (){
  },
  methods: {
    logoutCustomer () { 
      localStorage.clear()
      localStorage.removeItem('rccpcst')
      this.customerName = null
      this.customerEmail = null
      this.loggedIn = false
    },
    pageInit () {
      
      const loggedIn = localStorage.getItem('rccpcst')
      const pg = this.$route.name
      
      
      if(loggedIn ){
   
        const userObj = JSON.parse(loggedIn)

        this.pd = userObj.pd
        
        switch(pg) {
          case "SignIn":
            this.$router.push({ path: '/home' })
            break;
          default:
            this.getNavigation()
            this.loggedIn = true
            this.customerName = userObj.firstName
            this.customerEmail = userObj.email
        }

      }else{
        this.loggedIn = false
      }
    },
    searchPost() {
      //alert(this.$route.name) //SearchView
      /**/
      let searchPhrase = this.searchPortal

      if(searchPhrase){

        if(this.$route.name === 'SearchView'){
          this.$root.$emit("_searchContent",searchPhrase)
          this.searchPortal = ''
        }else{
          this.$router.push({
            name: 'SearchView',
            params: {
                search: searchPhrase
            }
          })
          this.searchPortal = ''
        }   
      }
      
    },
    getNavigation () {

      const userObj = JSON.parse(localStorage.getItem('rccpcst'))

      var endpoint = '/portal/settings'
      const url = process.env.VUE_APP_API_BASE_URL + endpoint

      let postData = {
        action: "navigation"
      }
      
      const request = new Request(url, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + userObj.jwt,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(postData),
        mode: 'cors',
      })  
      fetch(request)
      .then(response => {
        return response.json();
      })
      .then((jsonResponse) => {
         
         if(jsonResponse.success) {
          const navObj = JSON.parse(jsonResponse.data[0].category_schema_json)
          this.topNav = navObj // jsonResponse.data
          
          let navTop = []
          for (let i = 0; i < navObj.length; i++) {
            let obj = {
              category_id: navObj[i].category_id,
              category_name: navObj[i].category_name,
              category_name_display: navObj[i].category_name_display,
              category_slug: navObj[i].category_slug,
              category_description: navObj[i].category_description,
            }
            navTop.push(obj)
          }

          this.navigation.top = navTop // jsonResponse.data //set top nav
          this.$category.items = navTop // jsonResponse.data //make nav json available globally
        }

      })
    },
    showToasts (type,msg) {
      var options = {
        timeout: 3000,
        hideProgressBar: true,
      }
      switch (type) {
        case 'success':
          this.$toast.success(msg, options)
          break
        case 'info':
          this.$toast.info(msg, options)
          break
        case 'warning':
          this.$toast.warning(msg, options)
          break
        case 'error':
          this.$toast.error(msg, options)
          break    
        default:
          this.$toast(msg, options)
      }
    },
    pdlogin(to){
      
      const userObj = JSON.parse(localStorage.getItem('rccpcst'))

      var endpoint = '/portal/silent-login'
      const url = process.env.VUE_APP_API_BASE_URL + endpoint

      const postData = {
        name: userObj.name,
        firstName: userObj.firstName,
        email: userObj.email,
        initials: userObj.initials,
        id: userObj.ref,
        panel_designer: userObj.pd,
        company: userObj.company
      }
      
      const request = new Request(url, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + userObj.jwt,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(postData),
        mode: 'cors',
      })  
      fetch(request)
      .then(response => {
        return response.json();
      })
      .then((jsonResponse) => {
         
        
        if(jsonResponse.success){
          const ref = jsonResponse.ref  
          const redirectUrl = process.env.VUE_APP_PANEL_DESIGNER_URL + `?s=${ref}&d=${to}`
          window.location.href = redirectUrl
        }else{

          // handle error
        }

      })
      /*
      const userObj = JSON.parse(localStorage.getItem('rccpcst'))
      
      const postData = {
        name: userObj.name,
        firstName: userObj.firstName,
        email: userObj.email,
        initials: userObj.initials,
        id: userObj.ref,
        panel_designer: userObj.pd,
        company: userObj.company
      }
      
      var endpoint = '/silent-login'
      const url = process.env.VUE_APP_PANEL_DESIGNER_API_BASE_URL + endpoint

      const request = new Request(url, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + userObj.jwt,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
        mode: 'cors',
      })  
      fetch(request)
      .then(response => {
        return response.json();
      })
      .then((jsonResponse) => {
        
        if(jsonResponse.authorized){

         const ref = jsonResponse.ref  
         const redirectUrl = process.env.VUE_APP_PANEL_DESIGNER_URL + `?s=${ref}&d=${to}`
         //console.log(redirectUrl)
         window.location.href = redirectUrl
        }else{
          console.log(to)
        }

      })
        */
      
    }
  },
  watch: {
    '$route' () {
      this.pageInit()
    }
  },
  components: {

  }
};
</script>
<style>

#top-navigation{
  margin-top: 66px;
}
.top-nav-active{
  color: #b65c39 !important;
}
/*
.v-application, .modal-bg {
  background-color: #f4f4f4 !important; 
}
*/
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
